import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AddDepartmentLayer from "../components/AddDepartmentLayer";


const AddDepartmentPage = () => {
  return (
    <>
     
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Department  </h5><Breadcrumb title="Add Department" /></div>
        {/* AddUserLayer */}
        <AddDepartmentLayer />


    </>
  );
};

export default AddDepartmentPage;
